import { HttpClient, HttpParams } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { Observable, map } from "rxjs";
import { WalletRechargesPort } from "../../../app/ports/integration/wallet-recharges.port";
import {
  WalletRechargeFilters,
  WalletRechargesPageResponse,
} from "../../../domain/models/integration/wallet-recharges.model";
import { EnvMicroIntegration } from "../../config/env.micro.integration";
import { INTEGRATION_ENV } from "../../config/micros-env.tokens";
import {
  isStringList,
  isWalletRechargesPageResponse,
} from "../../validators/integration/wallet-recharges.validator";

@Injectable()
export class WalletRechargesHttpAdapter implements WalletRechargesPort {
  private static readonly PATH = "/api/v1/wallet-recharges";

  constructor(
    private readonly http: HttpClient,
    @Inject(INTEGRATION_ENV) private readonly env: EnvMicroIntegration,
  ) {}

  getProjects(): Observable<readonly string[]> {
    return this.getStringList(`${WalletRechargesHttpAdapter.PATH}/projects`);
  }

  getMembershipTypes(): Observable<readonly string[]> {
    return this.getStringList(`${WalletRechargesHttpAdapter.PATH}/membership-types`);
  }

  getRecharges(filters: WalletRechargeFilters): Observable<WalletRechargesPageResponse> {
    let params = new HttpParams()
      .set("page", filters.page)
      .set("size", filters.size);
    if (filters.search?.trim()) params = params.set("search", filters.search.trim());
    if (filters.project?.trim()) params = params.set("project", filters.project.trim());
    if (filters.membershipType?.trim()) {
      params = params.set("membershipType", filters.membershipType.trim());
    }
    if (filters.confirmationDate?.trim()) {
      params = params.set("confirmationDate", filters.confirmationDate.trim());
    }

    return this.http.get<unknown>(this.url(WalletRechargesHttpAdapter.PATH), { params }).pipe(
      map((response) => {
        if (!isWalletRechargesPageResponse(response)) {
          throw new Error("La respuesta de recargas de Wallet es inválida.");
        }
        return response;
      }),
    );
  }

  private getStringList(path: string): Observable<readonly string[]> {
    return this.http.get<unknown>(this.url(path)).pipe(
      map((response) => {
        if (!isStringList(response)) throw new Error("La respuesta del catálogo de recargas es inválida.");
        return response;
      }),
    );
  }

  private url(path: string): string {
    const baseUrl = `${this.env.host}${this.env.apiBasePath}`.replace(/\/$/, "");
    return `${baseUrl}${path}`;
  }
}
